const ERROR_CODES = {
  FILE_NOT_UPLOAD: 'file_not_upload',
};
const APPROVER_COMMENT_CODE = {
  MAX_LENGTH_ERROR: 'MAX_LENGTH_ERROR',
};

export { APPROVER_COMMENT_CODE, ERROR_CODES };
